import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

/**
 * Fetch again everything the screen is showing, for a pull down from the
 * top: the active queries are refetched in place, so where the member was
 * stays, as a phone's browser reloads a page without reloading the app.
 * A hook so the mobile shell, which imports only the library and the app's
 * data layer, does not reach for the query client itself.
 */
export function useRefetchOnScreen(): () => Promise<void> {
  const queryClient = useQueryClient();
  return useCallback(
    () => queryClient.refetchQueries({ type: 'active' }),
    [queryClient]
  );
}
